import { render, staticRenderFns } from "./person-edit-add.vue?vue&type=template&id=2f2f042e&scoped=true&"
import script from "./person-edit-add.vue?vue&type=script&lang=js&"
export * from "./person-edit-add.vue?vue&type=script&lang=js&"
import style0 from "./person-edit-add.vue?vue&type=style&index=0&id=2f2f042e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f042e",
  null
  
)

export default component.exports